export default "__VITE_ASSET__H5eI$LSl__"